var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmptyList"},[_c('div',{staticClass:"EmptyIconWrap"},[_c('img',{attrs:{"src":_vm.getEmptyIcon()}})]),_c('span',{staticClass:"EmptyText"},[_vm._v(_vm._s(_vm.mixWB('NO_PROJECTS_TO_SHOW')))])])}
var staticRenderFns = []

export { render, staticRenderFns }